module.exports = __webpack_public_path__ + "static/img/ill-warn.e8ab775.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/ill-warn.png
// module id = HMVY
// module chunks = 58